var scope_0 = require('/home/runner/work/HopeAllotment/HopeAllotment/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3a9178d73bd4a75b8001b58be404b126.js').default;
var scope_1 = require('/home/runner/work/HopeAllotment/HopeAllotment/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6efef2225db21abc28941a8c7ad523ce.js').default;
var scope_2 = require('/home/runner/work/HopeAllotment/HopeAllotment/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    